import { useVizChartTheme } from '../../hooks/useVizChartTheme';
import { useVizFormatters } from '../../hooks/useVizFormatters';
import { ColumnChartBlock } from '../../viz.types';
import { getVizBars, getVizSeriesColor } from '../../viz.utils';

export const useColumnChartBlock = (block: ColumnChartBlock) => {
  const formatters = useVizFormatters(block.format);
  const chartTheme = useVizChartTheme();

  const { bars, total } = getVizBars({ bars: block.bars, format: block.format });

  return {
    formatters,
    chartTheme,
    axisTick: { fontSize: chartTheme.axisFontSize, fill: chartTheme.axisColor },
    total: total === null ? null : formatters.formatCompact(total),
    chartMargin: { top: chartTheme.toPx(1), right: 0, left: 0, bottom: 0 },
    data: bars.map((bar, index) => ({
      label: bar.label,
      value: bar.value,
      fill: getVizSeriesColor({
        index,
        colors: chartTheme.seriesColors,
        opacities: chartTheme.seriesOpacities,
      }),
    })),
  };
};
